import * as React from 'react';
import { SVGProps } from 'react';

const IconFileProgramSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 3h18v2h2v16H4v-2H2V3Zm3 16v1h16V10h-1v9H5ZM20 9h1V6h-1v3ZM3 4v3h16V4H3Zm16 4H3v10h16V8Zm-5-2h-1V5h1v1Zm2 0h-1V5h1v1Zm2 0h-1V5h1v1Z"
    />
  </svg>
);
export default IconFileProgramSizeM;
